import classNames from "classnames";
import { useFormik } from "formik";
import { get, isEmpty } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BsTrash, BsUpload } from "react-icons/bs";
import { MdOpenInNew, MdOutlineRadioButtonChecked } from "react-icons/md";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";
import ImageJustification from "shared/assets/images/lmf/lmf_justificative.png";
import HelpYellow from "shared/components/SVG/LMF/HelpYellow";
import { NAME_SPACES } from "shared/locales/constants";
import { bytesToMB } from "utils/helpers/files";
import ActionButtons from "../Components/ActionButtons";
import Button from "../Components/Button";
import CustomModal from "../Components/CustomModal";
import Head from "../Components/Head";
import Input from "../Components/Input";
import Layout from "../Components/Layout";
import validation from "./validation";

const View = ({ initialValues, onSubmit, locked, translate, onBack }) => {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.PROCESSES);
  const [open, setOpen] = useState(false);
  const [modalInfo, setModalInfo] = useState(false);
  const { isValid, handleSubmit, setFieldValue, values, ...formProps } =
    useFormik({
      initialValues,
      onSubmit: onSubmit,
      validationSchema: validation(
        t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, {
          returnObjects: true,
        }),
      ),
    });

  const onFileRemove = async ({ uid: id }) => {
    if (id.indexOf("AUTO") !== -1) return;
  };

  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <>
      <CustomModal
        open={open}
        setOpen={setOpen}
        width={500}
        closeText={translate.MODAL.CLOSE}
      >
        <div className="with--link">
          <img src={ImageJustification} alt="Justification" />
          <Link
            to={
              "https://www.ameli.fr/assure/adresses-et-contacts/l-obtention-d-un-document/obtenir-une-attestation/obtenir-une-attestation-de-droits"
            }
            className="lmf__modal--link"
            target="_blank"
          >
            <span>{translate.MODAL.LINK}</span>
            <MdOpenInNew size={20} color="#FEC212" />
          </Link>
        </div>
      </CustomModal>

      <CustomModal
        open={modalInfo}
        setOpen={setModalInfo}
        title={translate.MODAL_INFO.TITLE}
        description={translate.MODAL_INFO.DESC}
        width={500}
        closeText={translate.MODAL.CLOSE}
      >
        <ul className="lmf__list">
          <li>
            <MdOutlineRadioButtonChecked />
            <span>{translate.MODAL_INFO.LIST.ITEM_1}</span>
          </li>
          <li>
            <MdOutlineRadioButtonChecked />
            <span>{translate.MODAL_INFO.LIST.ITEM_2}</span>
          </li>
          <li>
            <MdOutlineRadioButtonChecked />
            <span>{translate.MODAL_INFO.LIST.ITEM_3}</span>
          </li>
          <li>
            <MdOutlineRadioButtonChecked />
            <span>{translate.MODAL_INFO.LIST.ITEM_4}</span>
          </li>
        </ul>
      </CustomModal>

      <Layout>
        <Head
          description={translate.DESCRIPTION}
          title={translate.TITLE}
          onBack={onBack}
        />

        <div className="lmf__form grid--1 gap-24">
          <div className="justification__section--child">
            <Input
              type="file"
              variant="uploader"
              listType="picture"
              onUpload={(fileList) => {
                setFieldValue("bankAccountDetailsForPayment", fileList);
              }}
              validTypes={translate.DOCUMENTS.ALLOWED_FILES_TYPE}
              onFileRemove={onFileRemove}
              fileList={get(values, "bankAccountDetailsForPayment", [])}
            >
              {/* {isEmpty(get(values, "bankAccountDetailsForPayment")) && (
            )} */}
              <div className="upload">
                <div className="label">
                  <span>{translate.DOCUMENTS.TYPES.RIB_PRESTATION} </span>
                  {get(values, "bankAccountDetailsForPayment", []).map(
                    ({ name, size }, index) => (
                      <small key={`bankAccountDetailsForPayment-${index}`}>
                        {name} - {bytesToMB(size)}MB
                      </small>
                    ),
                  )}
                </div>
                <Button
                  type={
                    get(values, "bankAccountDetailsForPayment", []).length
                      ? "danger-outline"
                      : "white"
                  }
                  size="middle"
                  onClick={(e) => {
                    if (
                      get(values, "bankAccountDetailsForPayment", []).length
                    ) {
                      e.stopPropagation();
                      setFieldValue("bankAccountDetailsForPayment", []);
                    }
                  }}
                >
                  {get(values, "bankAccountDetailsForPayment", []).length ? (
                    <BsTrash size={20} />
                  ) : (
                    <BsUpload size={20} />
                  )}
                </Button>
              </div>
            </Input>
            {get(formProps.errors, "bankAccountDetailsForPayment") && (
              <span className="error-message">
                {get(formProps.errors, "bankAccountDetailsForPayment")}
              </span>
            )}
          </div>
          <div className="justification__section--child">
            <Input
              type="file"
              variant="uploader"
              listType="file"
              onUpload={(fileList) => {
                setFieldValue("childDependentProof", fileList);
              }}
              validTypes={translate.DOCUMENTS.ALLOWED_FILES_TYPE}
              onFileRemove={onFileRemove}
              fileList={get(values, "childDependentProof", [])}
            >
              {/* {isEmpty(get(values, "childDependentProof")) && (
            )} */}
              <div className="upload">
                <div className="label">
                  <span>{translate.DOCUMENTS.TYPES.JUSTIFICATION_CHILD}</span>
                  <div className="infos">
                    <span className="required">
                      {/* <small>Obligatoire</small> */}
                      <HelpYellow
                        onClick={(e) => {
                          e.stopPropagation();
                          setModalInfo(true);
                        }}
                        size={24}
                      />
                    </span>
                  </div>
                  {get(values, "childDependentProof", []).map(
                    ({ name, size }, index) => (
                      <small key={`childDependentProof-${index}`}>
                        {name} - {bytesToMB(size)}MB
                      </small>
                    ),
                  )}
                </div>
                <Button
                  type={
                    get(values, "childDependentProof", []).length
                      ? "danger-outline"
                      : "white"
                  }
                  size="middle"
                  onClick={(e) => {
                    if (get(values, "childDependentProof", []).length) {
                      e.stopPropagation();
                      setFieldValue("childDependentProof", []);
                    }
                  }}
                >
                  {get(values, "childDependentProof", []).length ? (
                    <BsTrash size={20} />
                  ) : (
                    <BsUpload size={20} />
                  )}
                </Button>
              </div>
            </Input>
            {get(formProps.errors, "childDependentProof") && (
              <span className="error-message">
                {get(formProps.errors, "childDependentProof")}
              </span>
            )}
          </div>
          <div className="justification__section--child">
            <Input
              type="file"
              variant="uploader"
              listType="picture"
              onUpload={(fileList) => {
                setFieldValue("healthInsuranceRightsCertificate", fileList);
              }}
              validTypes={translate.DOCUMENTS.ALLOWED_FILES_TYPE}
              onFileRemove={onFileRemove}
              fileList={get(values, "healthInsuranceRightsCertificate", [])}
              // fileList={get(values, "healthInsuranceRightsCertificate", [])}
            >
              {/* {isEmpty(get(values, "healthInsuranceRightsCertificate")) && (
            )} */}
              <div className="upload">
                <div className="label">
                  <span>
                    {
                      translate.DOCUMENTS.TYPES
                        .HEALTH_INSURANCE_RIGHTS_CERTIFICATE
                    }
                  </span>
                  <div className="infos">
                    <span className="required">
                      <small>Obligatoire</small>
                      <HelpYellow
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpen(true);
                        }}
                        size={24}
                      />
                    </span>
                    <small className="hint">Datant de -3 mois</small>
                  </div>
                  {get(values, "healthInsuranceRightsCertificate", []).map(
                    ({ name, size }, index) => (
                      <small key={`health-${index}`}>
                        {name} - {bytesToMB(size)}MB
                      </small>
                    ),
                  )}
                </div>
                <Button
                  type={
                    get(values, "healthInsuranceRightsCertificate", []).length
                      ? "danger-outline"
                      : "white"
                  }
                  size="middle"
                  onClick={(e) => {
                    if (
                      get(values, "healthInsuranceRightsCertificate", []).length
                    ) {
                      e.stopPropagation();
                      setFieldValue("healthInsuranceRightsCertificate", []);
                    }
                  }}
                >
                  {get(values, "healthInsuranceRightsCertificate", [])
                    .length ? (
                    <BsTrash size={20} />
                  ) : (
                    <BsUpload size={20} />
                  )}
                </Button>
              </div>
            </Input>
            {get(formProps.errors, "healthInsuranceRightsCertificate") && (
              <span className="error-message">
                {get(formProps.errors, "healthInsuranceRightsCertificate")}
              </span>
            )}
          </div>
        </div>

        <ActionButtons
          buttonText={translate.NEXT}
          onNext={handleSubmit}
          disabled={!isEmpty(formProps.errors)}
          {...(isMobile && { onBack })}
          className={classNames({
            "w-100": isMobile,
          })}
        />
      </Layout>
    </>
  );
};

export default View;
